/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  loadingRoleMappings: {
    id: `organization.security.role-mappings-table.loading-role-mappings`,
    defaultMessage: `Loading role mappings`,
  },
  noRoleMappings: {
    id: `organization.security.role-mappings-table.no-role-mappings`,
    defaultMessage: `No role mappings defined`,
  },
  nameColumn: {
    id: `organization.security.role-mappings-table.name-column`,
    defaultMessage: `Name`,
  },
  statusColumn: {
    id: `organization.security.role-mappings-table.status-column`,
    defaultMessage: `Status`,
  },
  rolesColumn: {
    id: `organization.security.role-mappings-table.roles-column`,
    defaultMessage: `Roles`,
  },
  actionsColumn: {
    id: `organization.security.role-mappings-table.actions-column`,
    defaultMessage: `Actions`,
  },
  enabledStatus: {
    id: `organization.security.role-mappings-table.enabled-status`,
    defaultMessage: `Enabled`,
  },
  disabledStatus: {
    id: `organization.security.role-mappings-table.disabled-status`,
    defaultMessage: `Disabled`,
  },
  removeRoleMapping: {
    id: `organization.security.role-mappings-table.remove-role-mapping`,
    defaultMessage: `Delete role mapping`,
  },
  editRoleMapping: {
    id: `organization.security.role-mappings-table.edit-role-mapping`,
    defaultMessage: `Edit role mapping`,
  },
  modalRemoveRoleMappingTitle: {
    id: `organization.security.role-mappings-table.modal-remove-role-mapping-title`,
    defaultMessage: `Delete role mapping?`,
  },
  modalRemoveRoleMappingMessage: {
    id: `organization.security.role-mappings-table.modal-remove-role-mapping-message`,
    defaultMessage: `The <b>{roleMappingName}</b> role mapping will be permanently deleted.`,
  },
  modalRemoveRoleMappingCancel: {
    id: `organization.security.role-mappings-table.modal-remove-role-mapping-cancel`,
    defaultMessage: `Cancel`,
  },
  modalRemoveRoleMappingConfirm: {
    id: `organization.security.role-mappings-table.modal-remove-role-mapping-confirm`,
    defaultMessage: `Delete role mapping`,
  },
  toastRemoveRoleMappingSuccess: {
    id: `organization.security.role-mappings-table.toast-remove-role-mapping-success`,
    defaultMessage: `Role mapping {roleMappingName} has been deleted.`,
  },
  toastRemoveRoleMappingError: {
    id: `organization.security.role-mappings-table.toast-remove-role-mapping-error`,
    defaultMessage: `Unknown error while deleting role mapping {roleMappingName}. Try again later.`,
  },
  modalRemoveOrgOwnerRoleMappingWarningTitle: {
    id: `organization.security.role-mappings-table.modal-remove-org-owner-role-mapping-warning-title`,
    defaultMessage: `This role mapping includes an Organization owner role assignment`,
  },
  modalRemoveOrgOwnerRoleMappingWarningDescription: {
    id: `organization.security.role-mappings-table.modal-remove-org-owner-warning`,
    defaultMessage: `Before the role is deleted, we'll validate your other role mappings to ensure you maintain the appropriate access to your organization without this role.`,
  },
  samlSsoIsNotConfigured: {
    id: `organization.security.role-mappings-table.saml-sso-is-not-configured`,
    defaultMessage: `To run this test, your organization must first set up and enable <link>SAML SSO</link>.`,
  },
  toastErrorTestRoleMapping: {
    id: `organization.security.role-mappings-table.toast-error-test-role-mapping`,
    defaultMessage: `Unknown error while testing deleting role mapping {roleMappingName}. Try again later.`,
  },
})

export const errorMessages = defineMessages({
  missingOrgOwnerRole: {
    id: `organization.security.role-mappings-table.error-missing-org-owner-role`,
    defaultMessage: `You cannot delete this role mapping. You must keep at least one enabled role mapping with the "Organization owner" role.`,
  },
})
